module.exports = __webpack_public_path__ + "img/food.b939a72f.png";